import Swal from "sweetalert2";
import "./ImageUploadProgress.css";

const ImageUploadProgress = {
    show: () => {
        Swal.fire({
            html: `
                <div class="image-upload-progress">
                    <div class="image-upload-circle">

                        <svg
                            class="image-upload-svg"
                            viewBox="0 0 120 120"
                        >
                            <circle
                                class="image-upload-circle-bg"
                                cx="60"
                                cy="60"
                                r="50"
                            />

                            <circle
                                id="image-upload-progress-circle"
                                class="image-upload-circle-progress"
                                cx="60"
                                cy="60"
                                r="50"
                            />
                        </svg>

                        <div
                            id="image-upload-progress-text"
                            class="image-upload-progress-text"
                        >
                            0%
                        </div>

                    </div>

                    <div
                        id="image-upload-progress-status"
                        class="image-upload-progress-status"
                    >
                        Please wait...
                    </div>
                </div>
            `,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            customClass: {
                popup: "image-upload-popup",
            },
        });
    },

    update: (percent, image) => {
        const circle = document.getElementById(
            "image-upload-progress-circle"
        );

        const text = document.getElementById(
            "image-upload-progress-text"
        );

        const status = document.getElementById(
            "image-upload-progress-status"
        );

        const circumference = 314;

        const offset =
            circumference -
            (percent / 100) * circumference;

        if (circle) {
            circle.style.strokeDashoffset = offset;
        }

        if (text) {
            text.innerText = `${percent}%`;
        }

        if (status) {
            status.innerText =
                percent === 100
                    ? "Processing..."
                    : `Uploading ${image.length === 1 ? "Image" : "Images"}...`;
        }
    },

    success: (message = "Images uploaded successfully!") => {
        Swal.fire({
            icon: "success",
            title: "Upload Complete!",
            text: message,
            timer: 2000,
            showConfirmButton: false,
        });
    },

    error: (
        message = "Something went wrong while uploading images."
    ) => {
        Swal.fire({
            icon: "error",
            title: "Upload Failed!",
            text: message,
        });
    },

    close: () => {
        Swal.close();
    },
};

export default ImageUploadProgress;
